module.exports = "<h3 md-dialog-title translate>shareApp</h3>\r\n\r\n<md-dialog-content>\r\n  <cm-social-share url=\"http://cinenow.ca\" (popUpClosed)=\"onPopUpClosed($event)\"></cm-social-share>\r\n</md-dialog-content>\r\n\r\n<md-dialog-actions align=\"end\">\r\n  <button md-button (click)=\"cancel()\" translate>close</button>\r\n</md-dialog-actions>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/dialog/share-dialog/share-dialog.component.html
// module id = ../../../../../src/app/dialog/share-dialog/share-dialog.component.html
// module chunks = 4